var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('friend-list-compornent',{key:_vm.componentKey,attrs:{"is-login-user":_vm.isLoginUser},on:{"rerender":_vm.rerender}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }